import React, { useEffect, useState } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import {
  Grid,
  IconButton,
  Paper,
  Typography,
  Menu,
  MenuItem,
  Button,
  TextField,
} from "@material-ui/core";
import {
  GroupAdd,
  MoreVert,
  FilterList,
  Clear,
  AddBox,
} from "@material-ui/icons";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import {
  TableroContainer,
  FileListAccordion,
  TextInputLimitado,
  FileInputWithPreview,
  HistorialTablero,
} from "./Components";
import {
  TarjetasArchivados,
  TablerosArchivados,
  HistorialSolicitudFechas,
  SolicitudesFechas,
} from "./Components/Tablas";

import FormNuevaSolicitud from "views/Solicitudes/FormNuevaSolicitud";
import { rectSortingStrategy } from "@dnd-kit/sortable";
import { contruirKeysFromData } from "./utils/funcionesiIndexTablero";
import { ModalFormularioV2Tablero, Page } from "components";
import FormTablero from "views/Tablero/Components/FormulariosTablero/FormTablero";
import FormCompartir from "views/Tablero/Components/FormulariosTablero/FormCompartir";
import FormFiltrar from "views/Tablero/Components/FormulariosTablero/FormFiltrar";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import { useForm } from "react-hook-form";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import serviciosTablero from "utils/serviciosTablero";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import { makeStyles } from "@material-ui/core/styles";

const Tablero = (props) => {
  const { idtablero, idjerarquia, idtipo, usuario, permisos } = props;
  const { register, errors, setValue, control, reset } = useForm();
  const classesTablero = useStylesTablero();
  const styles = {
    tituloTablero: { padding: "10px", fontSize: "22px" },
    panelTitulo: { backgroundColor: "#2B3B56", color: "#FFFFFF" },
    tableroDiv: { maxHeight: "75vh", overflowY: "hidden", overflowX: "auto" },
    botonCompartir: {
      color: "#000000",
      backgroundColor: "#FFFFFF",
      marginBottom: "10px",
    },
    botonQuitarFiltros: {
      color: "#FFFFFF",
      backgroundColor: "#e57373",
      marginBottom: "10px",
      marginRight: "5px",
    },
  };

  // const classesScroll = scrollStyles();

  // INICIAN CONFIGURACIONES DE DOCUMENTACION
  const saveFile = (dataBody, infoFolder) => {
    if (!infoFolder) {
      serviciosTablero.createFolder(
        (status, mensaje, response) => {
          if (status == 1) {
            response.archivos = [];
            setData((prevData) =>
              Array.isArray(prevData) ? [...prevData, response] : [response]
            );
            setModalDocumentation((prevData) => ({
              ...prevData,
              props: {
                ...prevData.props,
                data: Array.isArray(prevData.props.data)
                  ? [...prevData.props.data, response]
                  : [response], // Si `data` no es un arreglo, inicia un nuevo arreglo con `response`
              },
            }));

            setModalFolder((prevData) => ({
              ...prevData,
              open: false,
            }));
          }
        },
        setCargando,
        dataBody
      );
    } else {
      infoFolder["nombreCarpeta"] = dataBody["nombreCarpeta"];
      serviciosTablero.updateFolder(
        (status, mensaje, response) => {

          if (status == 1) {
            setData((prevData) =>
              prevData.map((item) =>
                item.idcarpeta === response.idcarpeta
                  ? { ...item, ...response }
                  : item
              )
            );
            setModalDocumentation((prevData) => ({
              ...prevData,
              props: {
                ...prevData.props,
                data: prevData.props.data.map((item) => {
                  if (item.idcarpeta === response.idcarpeta) {
                    // Actualizar los archivos dentro de `item.archivos`
                    const archivosActualizados = item.archivos.map((archivo) => {
                      // Quitar el "/" inicial de la ruta
                      const rutaSinSlash = archivo.ruta.startsWith("/")
                        ? archivo.ruta.slice(1)
                        : archivo.ruta;

                      // Buscar en `response.rutas_nuevas` el enlace correspondiente
                      const rutaCoincidente = response.rutas_nuevas.find((rutaNueva) => {
                        const ultimoValor = rutaNueva.name.split("/").pop(); // Último segmento del `name`
                        return ultimoValor === rutaSinSlash; // Comparar con la ruta sin "/"
                      });

                      // Si se encuentra coincidencia, actualizar el `url`
                      if (rutaCoincidente) {
                        return {
                          ...archivo,
                          url: rutaCoincidente.link, // Actualizar con el link encontrado
                        };
                      }

                      // Devolver el archivo sin cambios si no hay coincidencia
                      return archivo;
                    });

                    // Retornar el item con los archivos actualizados y toda la información del response
                    return {
                      ...item,
                      archivos: archivosActualizados, // Actualizar archivos
                      ...response, // Conservar toda la información del response
                    };
                  }

                  return item; // No modificar otros elementos
                }),
              },
            }));


            // setModalDocumentation((prevData) => ({
            //   ...prevData,
            //   props: {
            //     ...prevData.props,
            //     data: prevData.props.data.map((item) =>
            //       item.idcarpeta === response.idcarpeta
            //         ? { ...item, ...response }
            //         : item
            //     ),
            //   },
            // }));

            setModalChangeNameFolder((prevData) => ({
              ...prevData,
              open: false,
            }));
          }
        },
        setCargando,
        infoFolder
      );
    }
  };

  const parseArray = (valor) => {
    if (Array.isArray(valor)) return valor;

    if (valor && typeof valor === "object") {
      let arreglo = Object.values(valor);
      return arreglo;
    }

    return null;
  };

  const [modalFile, setModalFile] = useState({
    open: false,
    formulario: FileInputWithPreview,
    props: {},
    onCerrar: () => setModalFile((prevData) => ({ ...prevData, open: false })), // CERRANDO EL MODAL
    onOpen: () => setModalFile((prevData) => ({ ...prevData, open: true })), // ABRIENDO EL MODAL
    aceptar: (data) => {
      let infoFolder = null;
      setModalFile((prevData) => {
        infoFolder = prevData?.props?.infoFolder; // OBTENEMOS EL PROPS
        return prevData; // Retornamos el estado sin cambios
      });

      const formData = new FormData();
      formData.append("archivo", data?.file); // 'file' es el nombre del input tipo file

      formData.append(
        "info",
        JSON.stringify({
          idcarpeta: infoFolder.idcarpeta,
          nombreCarpeta: infoFolder.nombre,
          rutaCarpeta: infoFolder.ruta,
        })
      );

      serviciosTablero.createFile(
        (status, mensaje, response) => {
          setMensaje({ open: true, status: status, value: mensaje });
          if (status == 1) {
            // Aquí verificamos si el idcarpeta coincide con alguno en props.data
            setModalDocumentation((prevData) => {
              const updatedData = prevData.props.data.map((item) => {
                // Si encontramos el idcarpeta que coincide, actualizamos el item
                if (item.idcarpeta === infoFolder.idcarpeta) {
                  // Agregar el nuevo archivo a la lista de archivos
                  const updatedArchivos = [
                    ...(parseArray(item.archivos) || []),
                    response,
                  ];

                  return {
                    ...item,
                    archivos: updatedArchivos, // Actualizamos el objeto con la nueva lista de archivos
                  };
                }
                return item; // Retornamos el item sin cambios
              });

              // Retornamos el estado actualizado para modalDocumentation
              return {
                ...prevData,
                props: {
                  ...prevData.props,
                  data: updatedData, // Asignamos los datos actualizados
                },
              };
            });
            setModalFile((prevData) => ({ ...prevData, open: false }));
          }
        },
        setCargando,
        formData
      );
    },
    onDelete: (dataBody) => { },
  });

  const [modalFolder, setModalFolder] = useState({
    open: false,
    formulario: TextInputLimitado,
    props: {},
    onOpen: () => setModalFolder((prevData) => ({ ...prevData, open: true })), // ABRIENDO EL MODAL
    onCerrar: () =>
      setModalFolder((prevData) => ({ ...prevData, open: false })),
    aceptar: (dataBody) => {
      dataBody["idTablero"] = idtablero;
      saveFile(dataBody);
    }, // Aquí recibirás todos los datos del formulario
    openModalFile: (info) => {
      setModalFile((prevData) => ({
        ...prevData, // Mantiene los valores anteriores
        open: true, // Cambia solo `open` a `true`
        props: {
          ...prevData.props,
          infoFolder: info,
        },
      }));
    },
  });

  const [data, setData] = useState([]);

  const [modalDocumentation, setModalDocumentation] = useState({
    open: false,
    formulario: FileListAccordion,
    props: {
      data: data,
      idjerarquia: idjerarquia,
      usuario: usuario,
      permisos: permisos,
      updateFolder: (dataBody) => {
        setModalChangeNameFolder((prevData) => ({
          ...prevData,
          data: dataBody,
          open: true,
        }));
      },
      deleteFolder: (dataBody, dataFolder) => {
        let archivosActivos =
          dataBody?.archivos?.filter((archivo) => archivo?.idestatus !== -1) ||
          [];

        if (dataBody?.archivos && archivosActivos?.length == 0) {
          dataBody["idestatus"] = -1;
          if (dataFolder?.length > 0)
            dataBody["rutaCarpeta"] = dataFolder[0]?.ruta;
          serviciosTablero.updateFolder(
            (status, mensaje, response) => {
              setMensaje({ open: true, status: status, value: mensaje });
              if (status == 1) {
                setData((prevData) => [...(prevData || []), response]); // Agrega la nueva entrada al array
                setModalDocumentation((prevData) => ({
                  ...prevData,
                  props: {
                    ...prevData.props,
                    data: Array.isArray(prevData.props.data)
                      ? prevData.props.data.filter(
                        (item) => item.idcarpeta !== response.idcarpeta
                      )
                      : [], // Filtra elementos con `idcarpeta` diferente al de `response`, o inicia un arreglo vacío si `data` no es un arreglo
                  },
                }));
              }
            },
            setCargando,
            dataBody
          );
        } else {
          setMensaje({
            open: true,
            status: -1,
            value: "No es posible eliminar una carpeta con archivos",
          });
        }
      },
      deleteFile: (dataBody, dataFolder) => {
        dataBody["idestatus"] = -1;
        if (dataFolder?.length > 0)
          dataBody["rutaCarpeta"] = dataFolder[0]?.ruta;

        serviciosTablero.updateFile(
          (estatus, mensaje, response) => {
            setMensaje({ open: true, status: estatus, value: mensaje });
            setModalDocumentation((prevData) => {
              const updatedData = prevData.props.data.map((item) => {
                // Si encontramos el idcarpeta que coincide, actualizamos el archivo correspondiente
                if (item.idcarpeta === response.idcarpeta) {
                  const updatedArchivos = parseArray(item.archivos)?.map(
                    (archivo) => {
                      // Si el idarchivo coincide, actualizamos el archivo
                      if (archivo.idarchivo === response.idarchivo) {
                        return {
                          ...archivo,
                          ...response, // Actualizamos el archivo con los datos de response
                        };
                      }
                      return archivo; // Retornamos el archivo sin cambios si no coincide
                    }
                  );

                  return {
                    ...item,
                    archivos: updatedArchivos, // Actualizamos el objeto con la nueva lista de archivos
                  };
                }
                return item; // Retornamos el item sin cambios si no coincide el idcarpeta
              });

              // Retornamos el estado actualizado para modalDocumentation
              return {
                ...prevData,
                props: {
                  ...prevData.props,
                  data: updatedData, // Asignamos los datos actualizados
                },
              };
            });
          },
          setCargando,
          dataBody
        );
      },
    },
    onCerrar: () =>
      setModalDocumentation((prevData) => ({ ...prevData, open: false })), // CERRANDO EL MODAL
    onOpen: () => { },
    openModalFile: () =>
      setModalFile((prevData) => ({ ...prevData, open: true })),
    openModalFolder: () =>
      setModalFolder((prevData) => ({ ...prevData, open: true })),
    // setModalFolder((prevData) => ({ ...prevData, open: true })), // ABRIENDO EL MODAL
    aceptar: () => { },
  });

  const [modalChangeNameFolder, setModalChangeNameFolder] = useState({
    open: false,
    formulario: TextInputLimitado,
    props: {},
    onOpen: () =>
      setModalChangeNameFolder((prevData) => ({ ...prevData, open: true })), // ABRIENDO EL MODAL
    onCerrar: () =>
      setModalChangeNameFolder((prevData) => ({ ...prevData, open: false })),
    aceptar: (dataBody) => {
      let dataCarpeta = null;
      setModalChangeNameFolder((prevData) => {
        dataCarpeta = prevData?.data;
        return prevData;
      });
      if (dataCarpeta) {
        saveFile(dataBody, dataCarpeta);
      }
    },
  });
  // FINALIZAN CONFIGURACIONES DE DOCUMENTACION

  const waitPreview = (
    <>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{ height: "50px", margin: "10px 10px 0 10px" }}
        >
          <Skeleton animation="wave" variant="rect" />
        </Grid>
        <Grid item xs={4} style={{ height: "500px" }}>
          <Skeleton
            animation="wave"
            height={"100%"}
            variant="rect"
            style={{ marginLeft: "20px" }}
          />
        </Grid>
        <Grid item xs={4} style={{ height: "500px" }}>
          <Skeleton animation="wave" height={"100%"} variant="rect" />
        </Grid>
        <Grid item xs={4} style={{ height: "500px" }}>
          <Skeleton
            animation="wave"
            height={"100%"}
            variant="rect"
            style={{ marginRight: "20px" }}
          />
        </Grid>
      </Grid>
    </>
  );
  const [componenteTablero, setComponenteTablero] = useState({
    tipo: "wait",
    filtrosActivos: false,
    componente: waitPreview,
  });
  const [modalEditTablero, setModalEditTablero] = useState({ open: false });
  const [infoTablero, setInfoTablero] = useState();
  const [anchorEl, setAnchorEl] = useState({ current: null });
  const [ctlsForm, setCtlsForm] = useState({});
  const [openFiltrar, setOpenFiltrar] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });

  const cerrarFormTablero = () => setModalEditTablero({ open: false });
  const cerrarMensaje = () => setMensaje({ open: false });
  const abrirMenu = (row) => (event) => {
    setAnchorEl({ current: event.currentTarget, row: row });
  };
  const cerrarMenu = () => setAnchorEl({ ...anchorEl, current: null });
  const guardarParticipantes = (data) => {
    serviciosTablero.insertParticipantesTablero(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        setCtlsForm({
          participantesDisponibles: data?.participantesDisponibles || [],
          participantes: data?.participantes || [],
          clearOptions: true,
        });
      },
      setCargando,
      { ...data, idtablero: props.idtablero }
    );
  };
  const eliminarParticipantes = (data) => {
    serviciosTablero.eliminarParticipantesTablero(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        setCtlsForm({
          participantesDisponibles: data?.participantesDisponibles || [],
          participantes: data?.participantes || [],
          clearOptions: false,
        });
      },
      setCargando,
      { ...data, idtablero: props.idtablero }
    );
  };
  const editarTablero = (data) => {
    cerrarFormTablero();
    serviciosTablero.updateTablero(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status > 0) {
          cerrarFormTablero();
          cargarTablero();
        }
      },
      setCargando,
      { ...data, idtablero: props.idtablero }
    );
  };
  const abrirFormCompartir = () =>
    serviciosTablero.getParticipantesTablero(
      (data) => {
        setCtlsForm({
          participantesDisponibles: data?.participantesDisponibles || [],
          participantes: data?.participantes || [],
        });
        setModalEditTablero({
          open: true,
          titulo: "Compartir tablero",
          noActions: true,
          Componente: FormCompartir,
          props: {
            setCargando: setCargando,
            idtablero: props.idtablero,
            eliminarParticipantes: eliminarParticipantes,
            idjerarquia: idjerarquia,
            usuario: usuario,
          },
          aceptar: guardarParticipantes,
        });
      },
      setCargando,
      { idtablero: idtablero }
    );
  const abrirFormEditarTablero = () =>
    serviciosTablero.getCtlsTablero(
      (data) => {
        if (!data?.defaultData) {
          setMensaje({
            open: true,
            status: -1,
            value: "Error al obtener información del tablero",
          });
          return;
        }
        setCtlsForm({
          nombres: data?.participantes || [],
          solicitudes: data?.solicitudes || [],
        });
        setModalEditTablero({
          open: true,
          titulo: "Editar tablero",
          Componente: FormTablero,
          props: {
            setCargando: setCargando,
            idtablero: props.idtablero,
            action: "update",
            defaultValue: {
              titulo: data.defaultData.titulo,
              solicitud: data?.solicitudes?.find(
                (sol) => sol.idsolicitud == data.defaultData.idsolicitud
              ),
              lider: data?.defaultData?.lider,
              finicio: data.defaultData.finicioFormat,
              ffin: data.defaultData.ffinFormat,
            },
            idjerarquia: idjerarquia,
            usuario: usuario,
          },
          aceptar: editarTablero,
        });
      },
      setCargando,
      { action: "update", idtablero: props.idtablero }
    );

  const abrirFormFiltrar = () => {
    if (openFiltrar) {
      setOpenFiltrar(false);
      return;
    }
    serviciosTablero.getCtlsFiltros(
      (status, mensaje, data) => {
        if (status < 0)
          setMensaje({
            open: true,
            status: -1,
            value: "Error al obtener información.",
          });

        setCtlsForm({
          participantes: data?.participantes || [],
          solicitudes: data?.solicitudes || [],
          sistemas: data?.sistemas || [],
          infoTablero: infoTablero,
          usuario: usuario[0],
        });
        setOpenFiltrar(true);
      },
      setCargando,
      {
        idtablero: props.idtablero,
      }
    );
  };
  const abrirNuevaSolicitud = () =>
    serviciosSolicitudes.ctlSolicitud(
      (data) => {
        setModalEditTablero({
          open: true,
          width: "sm",
          titulo: "Crear nueva solicitud",
          Componente: FormNuevaSolicitud,
          props: {
            catalogos: {
              proyectos: data.proyectos,
              tipoincidencias: data.tipoincidencias,
              responsables: data.responsables ? data.responsables : [],
              prioridad: data.prioridad ? data.prioridad : [],
              areas: data?.areas || [],
              modulos: data?.modulos || [],
            },
            usuario: usuario[0],
          },
          aceptar: guardarNuevaSolicitud,
        });
      },
      setCargando,
      {}
    );

  const guardarNuevaSolicitud = (dataForm) => {
    let proyectoData = dataForm.proyecto;
    let narray = {
      ...dataForm,
      correo: dataForm.correo.map((email) => email.info),
    };
    let dataFormPivote = { ...narray };
    dataFormPivote.proyecto = dataFormPivote.proyecto.nproyecto;
    dataFormPivote.idproyecto = proyectoData.idproyecto;
    dataFormPivote.solicitante = dataFormPivote.solicitante;
    dataFormPivote.tipo_solicitud = dataFormPivote.tipo_solicitud.idopc; //`${usuario[0]?.nombre} ${usuario[0]?.apaterno} ${usuario[0]?.amaterno}`;
    dataFormPivote.tipo_app = dataFormPivote.tipo_app.opcion;
    dataFormPivote.idprioridad = dataFormPivote.idprioridad.idopc;
    dataFormPivote.area = dataFormPivote.area.area;
    dataFormPivote.idmodulo = dataFormPivote.modulo.idmodulo;

    const dataFormEstructura = new FormData();
    Object.keys(dataFormPivote).forEach((key) => {
      if (key != "filefield")
        dataFormEstructura.append(key, dataFormPivote[key]);
    });
    dataFormPivote.filefield.forEach((file) =>
      dataFormEstructura.append("filefield[]", file.file)
    );
    dataFormEstructura.append("estatusSelect", -1);
    serviciosSolicitudes.insertSolicitud(
      (status, mensaje, data) => {
        if (status > 0) {
          cerrarFormTablero();
          cargarTablero();
        }
        setMensaje({ open: true, status: status, value: mensaje });
      },
      setCargando,
      dataFormEstructura
    );
  };

  const enviarFiltros = (data) => {
    setComponenteTablero({
      tipo: "wait",
      filtrosActivos: false,
      componente: waitPreview,
    });
    if (usuario[0].idrol == 2 && idtipo == 2)
      data = {
        ...data,
        participantes: [usuario[0].idusuario],
      };
    serviciosTablero.getTablero(
      (status, mensaje, data) => {
        let dataKeys = contruirKeysFromData(data.estructura);
        setInfoTablero(data.info);
        setComponenteTablero({
          tipo: "tablero",
          filtrosActivos: true,
          componente: (
            <TableroContainer
              itemCount={5}
              strategy={rectSortingStrategy}
              horizontal
              items={dataKeys}
              dataOriginal={data.estructura}
              idtablero={props.idtablero}
              info={data.info}
              cargarTablero={cargarTablero}
              idjerarquia={idjerarquia}
              usuario={usuario}
              permisos={permisos}
            />
          ),
        });
      },
      setCargando,
      { idtablero: props.idtablero, filtros: data }
    );
  };

  const archivarTableroCall = () => {
    serviciosTablero.archivarTablero(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status > 0) {
          cerrarFormTablero();
          window.location.replace("/");
        }
      },
      setCargando,
      { idtablero: props.idtablero, idestatus: -1 }
    );
  };

  const abrirHistorialTablero = () =>
    setModalEditTablero({
      open: true,
      titulo: "Historial del tablero",
      Componente: HistorialTablero,
      props: {
        setCargando: setCargando,
        idtablero: props.idtablero,
        setMensaje: setMensaje,
      },
      noActions: true,
    });

  const abrirArchivadosTarjetas = () =>
    setModalEditTablero({
      open: true,
      titulo: "Tarjetas archivadas",
      Componente: TarjetasArchivados,
      props: {
        setCargando: setCargando,
        idtablero: props.idtablero,
        setMensaje: setMensaje,
        cargarTablero: cargarTablero,
        idjerarquia: idjerarquia,
        usuario: usuario,
        permisos: permisos,
      },
      noActions: true,
    });

  const abrirArchivadosTableros = () =>
    setModalEditTablero({
      open: true,
      titulo: "Tableros archivados",
      Componente: TablerosArchivados,
      props: {
        setCargando: setCargando,
        setMensaje: setMensaje,
        idjerarquia: idjerarquia,
        usuario: usuario,
        permisos: permisos,
      },
      noActions: true,
    });

  const abrirArchivarTablero = () => {
    let archivarTableroComponente = () => {
      return (
        <Typography>
          {
            "Si archiva el tablero ningún participante podrá verlo ¿Desea continuar?"
          }
        </Typography>
      );
    };
    setModalEditTablero({
      open: true,
      titulo: "Advertencia",
      Componente: archivarTableroComponente,
      props: {
        setCargando: setCargando,
        idtablero: props.idtablero,
        setMensaje: setMensaje,
      },
      aceptar: archivarTableroCall,
    });
  };
  const abrirSolicitudesFechas = () => {
    setModalEditTablero({
      open: true,
      titulo: "Solicitudes de fechas pendientes",
      Componente: SolicitudesFechas,
      props: {
        setCargando: setCargando,
        idtablero: props.idtablero,
        setMensaje: setMensaje,
        cargarTablero: cargarTablero,
      },
      noActions: true,
    });
  };

  const opcionesPanel = [
    {
      titulo: "Editar tablero",
      onClick: abrirFormEditarTablero,
      enabled:
        infoTablero?.idtipo == 2
          ? false
          : idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol),
    },
    {
      titulo: "Documentación",
      onClick: () => {
        serviciosTablero.getDocumentation(
          (status, mensaje, response) => {
            let dataResponse = parseArray(response);
            setData(dataResponse);
            setModalDocumentation((prev) => ({
              ...prev,
              open: true,
              props: {
                ...prev.props,
                data: dataResponse,
                idjerarquia: idjerarquia,
                usuario: usuario,
                permisos: permisos, // Aquí pasamos `response` directamente
              },
            }));
          },
          setCargando,
          { idTablero: idtablero }
        );
      },
      enabled: infoTablero?.idtipo == 1,
    },
    {
      titulo: "Historial tablero",
      onClick: abrirHistorialTablero,
      enabled: true,
    },
    {
      titulo: "Tarjetas archivadas",
      onClick: abrirArchivadosTarjetas,
      enabled: true,
    },
    {
      titulo: "Tableros archivados",
      onClick: abrirArchivadosTableros,
      enabled: infoTablero?.idtipo == 2,
    },
    {
      titulo: "Archivar tablero",
      onClick: abrirArchivarTablero,
      enabled:
        infoTablero?.idtipo == 2
          ? false
          : idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol),
    },
    {
      titulo: "Solicitudes cambio fecha",
      onClick: abrirSolicitudesFechas,
      enabled:
        infoTablero?.idtipo == 1 ? (infoTablero?.idtipo == 1 ? [3].includes(usuario[0]?.idrol)
          : idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol)) : "",

    },
  ];

  const cargarTablero = () => {
    setComponenteTablero({
      tipo: "wait",
      filtrosActivos: false,
      componente: waitPreview,
    });
    //llamar a funcion para traer datos de tablero
    let dataPost = { idtablero: props.idtablero };
    if (usuario[0].idrol == 2 && idtipo == 2)
      dataPost.filtros = {
        participantes: [usuario[0].idusuario],
      };

    serviciosTablero.getTablero(
      (status, mensaje, data) => {
        let dataKeys = contruirKeysFromData(data.estructura);

        setInfoTablero(data.info);
        setComponenteTablero({
          tipo: "tablero",
          filtrosActivos: false,
          componente: (
            <TableroContainer
              itemCount={5}
              strategy={rectSortingStrategy}
              horizontal
              items={dataKeys}
              dataOriginal={data.estructura}
              idtablero={props.idtablero}
              info={data.info}
              cargarTablero={cargarTablero}
              idjerarquia={idjerarquia}
              usuario={usuario}
              permisos={permisos}
            />
          ),
        });
      },
      setCargando,
      dataPost
    );
  };

  useEffect(() => {
    cargarTablero();
  }, []);
  return (
    <Page
      title="Tablero"
      className={{}}
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Grid container spacing={1}>
        {componenteTablero.tipo == "tablero" && (
          <>
            <Grid xs={12}>
              <Paper elevation={2} style={styles.panelTitulo}>
                <Grid container spacing={1}>
                  <Grid xs={8}>
                    <Typography style={styles.tituloTablero}>
                      {infoTablero.titulo}{" "}
                      {componenteTablero?.filtrosActivos === true
                        ? " (FILTROS ACTIVOS)"
                        : ""}
                    </Typography>
                  </Grid>
                  <Grid
                    xs={4}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "end",
                      alignItems: "flex-end",
                    }}
                  >
                    {infoTablero?.idtipo == 2 && (
                      <IconButton
                        title="Nueva solicitud"
                        onClick={abrirNuevaSolicitud}
                        style={{ color: "#FFFFFF" }}
                      >
                        <AddBox />
                      </IconButton>
                    )}
                    {componenteTablero?.filtrosActivos === true && (
                      <Button
                        style={styles.botonQuitarFiltros}
                        title="Limpiar filtros"
                        onClick={cargarTablero}
                        variant="filled"
                      >
                        <FilterList />
                        <Clear />
                      </Button>
                    )}
                    {infoTablero?.idtipo == 1 && (
                      <Button
                        style={styles.botonCompartir}
                        title="Agregar participantes"
                        onClick={abrirFormCompartir}
                        variant="filled"
                      >
                        <GroupAdd />
                        {" Compartir"}
                      </Button>
                    )}
                    <IconButton
                      title="Filtrar"
                      onClick={abrirFormFiltrar}
                      style={{ color: "#FFFFFF" }}
                    >
                      <FilterList />
                    </IconButton>
                    <IconButton
                      title="Opciones"
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={abrirMenu({})}
                      style={{ color: "#FFFFFF" }}
                    >
                      <MoreVert />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl.current}
                      keepMounted
                      open={Boolean(anchorEl.current)}
                      onClose={cerrarMenu}
                      className={classesTablero.menu}
                    >
                      {opcionesPanel.map((opcion, index) => (
                        <MenuItem
                          key={"OpcionFila" + index}
                          onClick={() => {
                            opcion.onClick();
                            cerrarMenu();
                          }}
                          style={{ display: opcion.enabled ? "block" : "none" }}
                        >
                          {opcion.titulo}
                        </MenuItem>
                      ))}
                    </Menu>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            {openFiltrar && (
              <Grid
                xs={12}
                style={{
                  backgroundColor:
                    componenteTablero.tipo == "tablero" ? "#060E1C" : "",
                  padding: "10px",
                }}
              >
                <FormFiltrar
                  ctls={ctlsForm}
                  setCtls={setCtlsForm}
                  enviarFiltros={enviarFiltros}
                />
              </Grid>
            )}
          </>
        )}

        <Grid
          xs={12}
          style={{
            ...styles.tableroDiv,
            backgroundColor:
              componenteTablero.tipo == "tablero" ? "#060E1C" : "",
          }}
        >
          <PerfectScrollbar
            options={{
              wheelSpeed: 1,
              suppressScrollY: true,
            }}
            style={{
              height: "100%", // Asegura que ocupe todo el contenedor
              overflow: "hidden", // Evita el scroll nativo
            }}
          >
            {componenteTablero.componente}
          </PerfectScrollbar>
        </Grid>
      </Grid>
      <ModalFormularioV2Tablero
        open={modalEditTablero?.open || false}
        width={modalEditTablero?.width || "md"}
        titulo={modalEditTablero?.titulo || ""}
        onCerrar={cerrarFormTablero}
        noActions={modalEditTablero?.noActions || false}
        aceptar={modalEditTablero.aceptar || false}
      >
        {modalEditTablero?.Componente && (
          <modalEditTablero.Componente
            {...modalEditTablero.props}
            ctls={ctlsForm}
            setCtls={setCtlsForm}
          />
        )}
      </ModalFormularioV2Tablero>
      <ModalFormularioV2Tablero
        open={modalDocumentation.open}
        width="md"
        titulo="DOCUMENTACIÓN"
        noActions={true}
        OnCancelar={modalDocumentation?.onCerrar}
        onCerrar={modalDocumentation?.onCerrar}
        aceptar={modalDocumentation?.aceptar}
      >
        {modalDocumentation.formulario && (
          <modalDocumentation.formulario
            catalogos={[]}
            {...modalDocumentation.props}
            openCreateFolderModal={modalDocumentation?.openModalFolder}
            handleAddFile={modalFolder?.openModalFile}
          />
        )}
      </ModalFormularioV2Tablero>
      <ModalFormularioV2Tablero
        open={modalFile.open}
        width="sm"
        titulo="AGREGAR ARCHIVO"
        OnCancelar={modalFile.onCerrar}
        aceptar={modalFile.aceptar}
        onCerrar={modalFile.onCerrar}
      >
        {modalFile.formulario && (
          <modalFile.formulario
            catalogos={[]}
            {...modalFile.props}
          // openCreateFolderModal={openCreateFolderModal}
          />
        )}
      </ModalFormularioV2Tablero>
      <ModalFormularioV2Tablero
        open={modalFolder.open}
        width="sm"
        titulo="AGREGAR CARPETA"
        OnCancelar={modalFolder.onCerrar}
        aceptar={modalFolder.aceptar}
        onCerrar={modalFolder.onCerrar}
      >
        {modalFolder.formulario && (
          <modalFolder.formulario
            catalogos={[]}
            {...modalFolder.props}
          // openCreateFolderModal={openCreateFolderModal}
          />
        )}
      </ModalFormularioV2Tablero>
      <ModalFormularioV2Tablero
        open={modalChangeNameFolder.open}
        width="sm"
        titulo="EDITAR CARPETA"
        mensajeConfirmacion={true}
        OnCancelar={modalChangeNameFolder.onCerrar}
        aceptar={modalChangeNameFolder.aceptar}
        onCerrar={modalChangeNameFolder.onCerrar}
      >
        {modalChangeNameFolder.formulario && (
          <modalChangeNameFolder.formulario
            catalogos={[]}
            {...modalChangeNameFolder.props}
          // openCreateFolderModal={openCreateFolderModal}
          />
        )}
      </ModalFormularioV2Tablero>
    </Page>
  );
};

export default Tablero;
